export enum ToleranceRange {
    BEFORE = "before",
    AFTER = "after",
    BOTH = "both",
}

export enum TolerancePeriod {
    DAYS = "days",
    MONTHS = "months",
    YEARS = "years",
}
